import React from "react";

const Policy = ({ onBack }) => {

  return (
    <div className="min-h-screen">

      <div className="w-full flex items-center" style={{
            background: "linear-gradient(to bottom, rgba(225, 225, 225, 1) 0%, rgba(225, 225, 225, 0) 100%)",
            padding: "35px 21px 26px"
      }}>
        <button
          onClick={onBack}
          className=" absolute top-[34px] bg-white rounded-full p-1 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-400"
            fill="none"
            viewBox="0 0 26 26"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <h1 className="text-[20px] leading-[20px] font-normal font-young-serif text-center mx-auto">
          Privacy Policy
        </h1>
      </div>
      <div className="mx-7 border-t border-[#EEEEEE]" />

      <div className="rounded-xl text-[16px] font-young-serif  p-6">
        <p className="text-[#000000] text-[16px] leading-[20px] font-normal font-space-grotesk">
        NXTLVL Education Ltd (“we“, “us”) is committed to protecting and respecting your privacy.
        The website at https://www.nxtlvl.io// (our “Website”) and services are meant to provide a space for children from different parts of the world to connect and develop skills like creativity,
        critical-thinking and communication through game-based learning.



    </p>  </div>
    </div>
  );
};

export default Policy;
